/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { TuteurLieuFormationGridDto } from './TuteurLieuFormationGridDto';
import {
    TuteurLieuFormationGridDtoFromJSON,
    TuteurLieuFormationGridDtoFromJSONTyped,
    TuteurLieuFormationGridDtoToJSON,
} from './TuteurLieuFormationGridDto';

/**
 * 
 * @export
 * @interface TuteurLieuFormationGridDtoPaginatedResults
 */
export interface TuteurLieuFormationGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof TuteurLieuFormationGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<TuteurLieuFormationGridDto>}
     * @memberof TuteurLieuFormationGridDtoPaginatedResults
     */
    results?: Array<TuteurLieuFormationGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof TuteurLieuFormationGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the TuteurLieuFormationGridDtoPaginatedResults interface.
 */
export function instanceOfTuteurLieuFormationGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurLieuFormationGridDtoPaginatedResultsFromJSON(json: any): TuteurLieuFormationGridDtoPaginatedResults {
    return TuteurLieuFormationGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function TuteurLieuFormationGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurLieuFormationGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(TuteurLieuFormationGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function TuteurLieuFormationGridDtoPaginatedResultsToJSON(value?: TuteurLieuFormationGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(TuteurLieuFormationGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

